import moment from "moment";
import {presenceConfirm} from "api";

function addLeadZero(value) {
    if (value < 10) {
        return '0' + value;
    }

    return value;
}

export default function($app) {
    const $comet = $app.require('comet');
    const $statistic = $app.require('statistic');

    this.activeCheck = ko.observable(null);
    this.activeCheckTimeout = ko.observable(null);
    this.activeCheckTimeoutFormatted = ko.computed(() => {
        if (null === this.activeCheckTimeout() || this.activeCheckTimeout() < 0) {
            return null;
        }

        const minutes = Math.floor(this.activeCheckTimeout() / 60);
        const seconds = this.activeCheckTimeout() % 60;

        return addLeadZero(minutes) + ':' + addLeadZero(seconds);
    });

    this.handleConfirm = async () => {
        const eventKey = $app.event().eventKey();
        const cometChannel = $statistic.getCometChannel();

        await presenceConfirm(eventKey, cometChannel)
        onCheckStop();
    };

    const updateTimeout = () => {
        if (null === this.activeCheck()) {
            this.activeCheckTimeout(null);

            return;
        }

        this.activeCheckTimeout(this.activeCheck().timeStop - moment().unix());

        setTimeout(updateTimeout, 1000);
    };

    const onCheckStart = (presence) => {
        this.activeCheck(presence);

        setTimeout(() => {
            if (this.activeCheck() && this.activeCheck().id === presence.id) {
                this.activeCheck(null);
            }
        }, (presence.timeStop - moment().unix()) * 1000)

        updateTimeout();
    };
    const onCheckStop = () => {
        this.activeCheck(null);
    };

    $app.on('start', () => {
        $comet
            .on('start:presence', onCheckStart)
            .on('stop:presence', onCheckStop)
        ;
    });
}
